import { ComponentProps } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Sizes, Svg, Typography } from '@altermaind/web/ui';
import { linksDoc } from '@/_shared/constants';
import { usePublicDocs } from '@/_shared/hooks/usePublicDocs';

type Props = Omit<ComponentProps<typeof Button>, 'children'> & {
  label?: string;
  prefixIcon?: string;
  suffixIcon?: string;
  iconSize?: keyof Sizes;
  goTo?: keyof typeof linksDoc;
};

export const GoToPublicsDocs = ({
  label,
  goTo,
  prefixIcon = 'help',
  suffixIcon,
  iconSize = 's',
  ...props
}: Props) => {
  const t = useTranslations('goToPublicsDocs');

  const { goToPublicsDocs } = usePublicDocs();

  return (
    <Button
      onClick={() => goToPublicsDocs({ goTo })}
      textAlign='left'
      variant='link/primary'
      mb='s'
      mt='none'
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {!suffixIcon && (
        <Box mr='xxxs' display='flex'>
          <Svg name={prefixIcon} size={iconSize} />
        </Box>
      )}
      <Typography variant='p2'>{label || t('label')}</Typography>
      {suffixIcon && (
        <Box ml='xxxs' display='flex'>
          <Svg ml='xxxs' name={suffixIcon} size={iconSize} />
        </Box>
      )}
    </Button>
  );
};
